import { media } from '@hellodarwin/core/web/theme/mixins/responsive';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css, Interpolation } from 'styled-components';

export interface StyledAssetProps {
  $tablet?: Interpolation<object>;
  $default?: Interpolation<object>;
  $xl?: Interpolation<object>;
  $lg?: Interpolation<object>;
}

export const GatsbyImageStyled = styled(GatsbyImage)<StyledAssetProps>`
  max-width: 100%;
  height: auto;

  ${media.xl`
    max-height:550px;
    `}
  ${({ $xl, $default, $tablet, $lg }) => css`
    ${$default};
    ${media.xxl`${$xl}`};
    ${media.xl`${$lg}`};
    ${media.tablet`${$tablet}`};
  `}
`;

export const StandardImageStyled = styled.img<StyledAssetProps>`
  ${({ $xl, $default, $tablet, $lg }) => css`
    ${$default};
    ${media.xxl`${$xl}`};
    ${media.xl`${$lg}`};
    ${media.tablet`${$tablet}`};
  `}
`;
